import Page from "../../components/Page";
import Loader from "../../components/Loader/Loader";
import { useEffect, useState } from "react";
import CONFIG from "../../utils/config";
import LearningPathSurveyReportHomeSection from "../../components/Reports/LearningPathSurveyReport/LearningPathSurveyReportHomeSection";

export const LearningPathSurveyReportMobile = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight }
            console.log('height: ', obj);
            window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])

    return (
        <>
            <Loader start={isLoading} />
            {/* <Page> */}
                <LearningPathSurveyReportHomeSection
                    setIsLoading={setIsLoading} 
                    isLoading={isLoading}
                    isMobile={true}
                />
            {/* </Page> */}
        </>
    )
}

export default LearningPathSurveyReportMobile;